﻿export class trip_passenger {
    public index: number = 0;
}